var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.users,
          columns: _vm.columns_users,
          "row-key": "user_id",
          pagination: _vm.pagination,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          filter: _vm.filter_users,
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          },
          request: _vm.requestUserDrills
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    icon: "far fa-search",
                    placeholder: _vm.$t("search"),
                    debounce: 500
                  },
                  model: {
                    value: _vm.filter_users,
                    callback: function($$v) {
                      _vm.filter_users = $$v
                    },
                    expression: "filter_users"
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n                "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  {
                    staticClass: "cursor-pointer",
                    attrs: { props: props },
                    nativeOn: {
                      click: function($event) {
                        return _vm.showDrillUsersResult(props.row)
                      }
                    }
                  },
                  [
                    _c("q-td", { key: "full_name", attrs: { props: props } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(props.row.full_name) +
                          "\n                    "
                      )
                    ]),
                    _c("q-td", { key: "email", attrs: { props: props } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(props.row.email) +
                          "\n                    "
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "result_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.fDate(props.row.result_date)) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "qty_correct_answers", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(props.row.qty_correct_answers) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "qty_wrong_answers", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(props.row.qty_wrong_answers) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        props.row.status || props.row.expired
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "full-width text-center",
                                attrs: {
                                  small: "",
                                  icon: _vm.getIconStatusUser(props.row),
                                  color: _vm.getColorStatusUser(props.row)
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t(_vm.getTextStatusUser(props.row))
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_drill_users_result,
            callback: function($$v) {
              _vm.show_drill_users_result = $$v
            },
            expression: "show_drill_users_result"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_drill_users_result = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.drill.title) +
                        "\n                    "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end question-list" },
                  _vm._l(_vm.drill_result, function(question, index) {
                    return _c(
                      "div",
                      {
                        key: "drill-" + index,
                        staticClass: "col-xs-12 col-sm-12"
                      },
                      [
                        _c(
                          "span",
                          { class: _vm.getQuestionClass(index, question) },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(index + 1) +
                                ") "
                            ),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(question.title) }
                            })
                          ]
                        ),
                        _c(
                          "q-field",
                          {
                            attrs: { error: question.error, "error-label": "_" }
                          },
                          [
                            _c("q-option-group", {
                              staticClass: "questions q-mt-xs",
                              class: question.is_correct
                                ? "checkbox-hit"
                                : question.is_correct == null
                                ? ""
                                : "checkbox-error",
                              attrs: {
                                type: "radio",
                                options: question.answers,
                                readonly: ""
                              },
                              on: {
                                input: function($event) {
                                  question.error = false
                                }
                              },
                              model: {
                                value: question.user_answer_id,
                                callback: function($$v) {
                                  _vm.$set(question, "user_answer_id", $$v)
                                },
                                expression: "question.user_answer_id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }